export default __webpack_public_path__ + "97bbe6efe8dcd954038aac0b4ef876c1.png";